document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('.collectionGrid'); // Replace with your grid's CSS class
  if (grid) {
    const items = Array.from(grid.getElementsByClassName('productCard__cluster')); // Replace with your item class
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      grid.insertBefore(items[j], items[i]);
    }
  }
});

(function(){
  if(window.__bgcLazyWatch)return;window.__bgcLazyWatch=!0;
  var load=function(img){if(img.dataset.src)img.src=img.dataset.src;img.classList.remove('lazy')};
  var io='IntersectionObserver'in window?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);load(e.target)}})},{rootMargin:'200px'}):null;
  var scan=function(){document.querySelectorAll('img.lazy[data-src]').forEach(function(img){
    if(img.__bgcLazy)return;img.__bgcLazy=1;
    if(!io||img.closest('.product-list--scrollable'))load(img);else io.observe(img);
  })};
  var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(scan,50)}).observe(document.documentElement,{childList:true,subtree:true});
})();

document.addEventListener('skufu:notify:cards',function(){window.dispatchEvent(new Event('resize'))});